var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaunchpad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3993 13.1776C9.96942 15.6075 6.02972 15.6075 3.59979 13.1776C2.38483 11.9626 1.77735 10.3702 1.77734 8.77778C1.77734 7.18537 2.38482 5.59296 3.59979 4.37799C3.59979 4.37799 4.11071 5.66663 5.66627 6.44441C5.66627 4.88886 6.05516 2.55552 7.98859 1C9.55513 2.55556 11.1816 3.16024 12.3993 4.378C13.6143 5.59296 14.2218 7.18537 14.2218 8.77778C14.2218 10.3702 13.6143 11.9626 12.3993 13.1776Z",
    stroke: "#6B7280",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.34965 11.2054C7.26088 12.1167 8.73826 12.1167 9.64949 11.2054C10.1051 10.7498 10.3329 10.1527 10.3329 9.55555C10.3329 8.95839 10.1051 8.36123 9.64949 7.90561C9.19676 7.45288 8.60427 7.22508 8.0109 7.22222L7.22175 9.55551L5.66624 9.55555C5.66624 10.1527 5.89405 10.7498 6.34965 11.2054Z",
    stroke: "#6B7280",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunchpad);
export default __webpack_public_path__ + "static/media/launchpad.f4c83a150070f68f9322f0dd8310922f.svg";
export { ForwardRef as ReactComponent };